<template>
  <c-form @submit.prevent="submit">

    <c-title>Neues Passwort erstellen</c-title>

    <c-form-input
      id="password"
      :errors="[]"
      :has-error="false"
      :is-valid="!$v.password.$invalid"
      v-model="password"
      aria-required="true"
      autocomplete="new-password"
      label="Passwort"
      type="password"
      @input="$v.password.$touch"
    />

    <c-password-strength-indicator 
      :password="password" 
      :show-requirements="true" 
    />

    <c-form-input
      id="passwordRepeat"
      :errors="[{
        message: 'Pflichtfeld',
        show: !$v.passwordRepeat.required
      }, {
        message: 'Ihre Passwörter müssen übereinstimmen.',
        show: !$v.passwordRepeat.sameAs
      }]"
      :has-error="$v.passwordRepeat.$error"
      :is-valid="!$v.passwordRepeat.$invalid"
      v-model="passwordRepeat"
      aria-required="true"
      autocomplete="new-password"
      label="Passwort wiederholen"
      type="password"
      @input="$v.passwordRepeat.$touch"
    />

    <c-button :busy="saveStatus === $config.status.SAVING">
      Passwort ändern
    </c-button>

    <router-link :to="{ name: 'login' }">
      Zum Login
    </router-link>

  </c-form>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CPasswordStrengthIndicator from '@/components/form/CPasswordStrengthIndicator'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'
import { required, sameAs } from 'vuelidate/lib/validators'
import { strongPassword } from '@/functions/validators'

export default {
  name: 'VSetPassword',

  components: {
    CButton,
    CForm,
    CFormInput,
    CPasswordStrengthIndicator,
    CTitle
  },

  props: {
    identifier: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      saveStatus: this.$config.status.IDLE,
      password: '',
      passwordRepeat: '',
      token: ''
    }
  },

  validations: {
    password: {
      required,
      strongPassword
    },
    passwordRepeat: {
      required,
      sameAs: sameAs('password')
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte füllen Sie alle Felder korrekt aus.',
          type: 'error'
        })

        return
      }

      this.saveStatus = this.$config.status.SAVING

      this.$api.post('auth/reset/', {
        password: this.password,
        identifier: this.identifier.replace('%3A', ':')
      })
        .then(response => {
          this.$store.commit('notifications/add', {
            text: 'Ihr Passwort wurde erfolgreich geändert. Bitte melden Sie sich mit Ihren neuen Zugangsdaten an.',
            type: 'success'
          })
          this.$router.push({ name: 'login' })
        })
        .catch(error => {
          handleRequestError({
            error,
            fallback: 'Ihr Passwort kann zurzeit leider nicht geändert werden. Bitte versuchen Sie es später erneut.'
          })

          this.saveStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
